import Document from "../components/Document";

export default function OfferPage() {
    const offerUrl = 'https://drive.google.com/file/d/1tvdaTow_6bjS8kCTscjI-zaHj2Qqu7G7/preview';
    return (
        <Document url={offerUrl} title='Offer' />
    )
}